module.exports = __webpack_public_path__ + "img/title.ba32c96b.png";